import { i18nMark, Trans } from 'lingui-react';
import { curry } from 'lodash';
import React from 'react';

import { milesToMeters } from 'utils/measure';
import { isMetric } from 'utils/unit';

import DealerLocatorContext from '../DealerLocatorContext';

export const searchAreaOptionsInMiles = [10, 25, 50, 100, 150, 200];
export const searchAreaOptionsInKm = [16, 40, 80, 160, 240, 320];
export const searchRouteOptionsInMiles = [5, 10, 15, 20, 25];
export const searchRouteOptionsInKm = [8, 16, 24, 40, 80];

export function getProximityFilters({ isRouteSearch, unit }) {
  if (isRouteSearch) {
    return isMetric(unit) ? searchRouteOptionsInKm : searchRouteOptionsInMiles;
  }

  return isMetric(unit) ? searchAreaOptionsInKm : searchAreaOptionsInMiles;
}

export function getProximityFilterLabel({ unit }) {
  return isMetric(unit)
    ? i18nMark('{proximityFilterValue} Kilometers')
    : i18nMark('{proximityFilterValue} Miles');
}

export function getSelectedProximityFilterIndex({
  isRouteSearch,
  searchAreaDistanceFilterIndex,
  searchRouteDistanceFilterIndex,
}) {
  return isRouteSearch
    ? searchRouteDistanceFilterIndex
    : searchAreaDistanceFilterIndex;
}

export function getProximityDistance(
  { unit },
  proximityFilters,
  selectedProximityFilterIndex,
) {
  const value = proximityFilters[selectedProximityFilterIndex];
  return isMetric(unit) ? value * 1000 : milesToMeters(value);
}

export const updateSelectedProximityFilterIndex = curry(
  (
    { isRouteSearch, updateDealerLocatorContext: setContext },
    event,
    filterIndex,
  ) => {
    if (isRouteSearch) {
      return setContext({
        searchRouteDistanceFilterIndex: filterIndex,
      });
    }

    return setContext({
      searchAreaDistanceFilterIndex: filterIndex,
    });
  },
);

export const buildConsumerChild = curry(
  (WrappedComponent, componentProps, consumerProps) => {
    const proximityFilters = getProximityFilters(consumerProps);
    const proximityFilterLabel = getProximityFilterLabel(consumerProps);
    const selectedProximityFilterIndex = getSelectedProximityFilterIndex(
      consumerProps,
    );
    const proximityDistance = getProximityDistance(
      consumerProps,
      proximityFilters,
      selectedProximityFilterIndex,
    );

    return (
      <WrappedComponent
        {...componentProps}
        proximityDistance={proximityDistance}
        proximityFilters={proximityFilters}
        proximityFilterLabel={proximityFilterLabel}
        selectedProximityFilterIndex={selectedProximityFilterIndex}
        selectedProximityFilterLabel={
          <Trans
            id={proximityFilterLabel}
            values={{
              proximityFilterValue:
                proximityFilters[selectedProximityFilterIndex],
            }}
          />
        }
        onSelectProximityFilter={updateSelectedProximityFilterIndex(
          consumerProps,
        )}
      />
    );
  },
);

const withProximityFilters = WrappedComponent => componentProps => (
  <DealerLocatorContext.Consumer>
    {buildConsumerChild(WrappedComponent, componentProps)}
  </DealerLocatorContext.Consumer>
);

export default withProximityFilters;



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/withProximityFilters/index.js